import React from 'react';
import '../styles/Portfolio.css';

const highlights = [
  { label: 'National Award', value: 'Best Education Provider 2023' },
  { label: 'Alumni Network', value: '25,000+ Alumni' },
  { label: 'Courses Offered', value: '200+ Courses' },
];

const categories = [
  {
    title: 'Community Outreach',
    items: ['Digital Literacy Initiative', 'Educated 5,000+ individuals'],
    location: 'Various communities',
    meta: '50+ Volunteers',
  },
  {
    title: 'Research & Development',
    items: ['Innovation Lab', '10+ educational tools'],
    location: 'Main Campus',
    meta: '20+ Collaborators',
  },
  {
    title: 'International Collaboration',
    items: ['Global Exchange Program', '15+ partner institutions'],
    location: 'Global',
    meta: '10+ Countries',
  },
  {
    title: 'Alumni Achievements',
    items: ['Career Success Stories', '100+ alumni highlights'],
    location: 'Worldwide',
    meta: '100+ Stories',
  },
  {
    title: 'Academic Excellence',
    items: ['Research Publications', '200+ peer-reviewed papers'],
    location: 'Academic Journals',
    meta: '200+ Publications',
  },
  {
    title: 'Corporate Collaboration',
    items: ['Industry Partnerships', '30+ companies involved'],
    location: 'Corporate Offices',
    meta: '30+ Partners',
  },
];

const testimonials = [
  {
    name: 'Sarah Kim',
    role: 'Software Engineer',
    quote: 'ICITY Education transformed my career. The practical experience and industry connections were invaluable.',
  },
  {
    name: 'James Wilson',
    role: 'Global Brand Manager',
    quote: 'The global exchange program broadened my horizons and helped me form lasting professional relationships.',
  },
];

const Portfolio = () => (
  <section className="portfolio">
    <h2>Our Impact & Collaborations</h2>

    <div className="stats">
      {highlights.map((item, i) => (
        <div key={i} className="stat-card">
          <h3>{item.label}</h3>
          <p>{item.value}</p>
        </div>
      ))}
    </div>

    <div className="portfolio-grid">
      {categories.map((cat, i) => (
        <div key={i} className="portfolio-card">
          <h3>{cat.title}</h3>
          <ul>
            {cat.items.map((item, j) => <li key={j}>{item}</li>)}
          </ul>
          <p><strong>Location:</strong> {cat.location}</p>
          <p><strong>{cat.meta}</strong></p>
        </div>
      ))}
    </div>

    <div className="testimonials">
      <h3>Shared Success Stories</h3>
      {testimonials.map((t, i) => (
        <div key={i} className="testimonial">
          <p>"{t.quote}"</p>
          <span>— {t.name}, {t.role}</span>
        </div>
      ))}
    </div>
  </section>
);

export default Portfolio;
